module.exports = "<simple-crud service=\"offers.service\" translations=\"offers.translations\" fields=\"offers.fields\"></simple-crud>"


//////////////////
// WEBPACK FOOTER
// ./client/app/manager/offers/offers.pug
// module id = 225
// module chunks = 0